import { browser } from '$app/environment';
import { writable } from 'svelte/store';

type Theme = 'light' | 'dark';

// Get initial theme from localStorage or system preference
const getInitialTheme = (): Theme => {
	if (!browser) return 'light';

	const savedTheme = localStorage.getItem('theme') as Theme;
	if (savedTheme) return savedTheme;

	return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

export const theme = writable<Theme>(getInitialTheme());

// Update localStorage and document class when theme changes
theme.subscribe((value) => {
	if (!browser) return;

	localStorage.setItem('theme', value);
	document.documentElement.dataset.colorScheme = value;
	if (value === 'dark') {
		document.documentElement.classList.add('dark');
	} else {
		document.documentElement.classList.remove('dark');
	}
});
